import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';

import { Platform, ToastController, NavController, IonRouterOutlet, LoadingController, MenuController, AlertController } from '@ionic/angular';
// import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';

// import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
// // import { Observable } from 'rxjs';
import { LocationAccuracy } from '@ionic-native/location-accuracy';
// import { BackgroundMode } from '@awesome-cordova-plugins/background-mode/ngx';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { GlobalPage } from './global/global.page';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
// import { Firebase } from "@ionic-native/firebase/ngx";
import { LoginPage } from './login/login.page';
import { UserdetailPage } from './userdetail/userdetail.page';
import { DashboardPage } from './dashboard/dashboard.page';
import { Device } from '@awesome-cordova-plugins/device/ngx';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { StatusBar } from '@ionic-native/status-bar/ngx';
// import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic';
import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
import { Network } from '@ionic-native/network/ngx';
import $ from "jquery";
import { AltLoginPage } from './alt-login/alt-login.page';
import { DriverManagementPage } from './driver-management/driver-management.page';
import { PendingPage } from './pending/pending.page';
import { LivePage } from './live/live.page';
import { CompletedPage } from './completed/completed.page';
import BackgroundGeolocation from 'cordova-background-geolocation-lt';
import { interval, Observable } from 'rxjs';
import { Storage } from '@ionic/storage-angular';
import { Location } from '@angular/common';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { GeolocationService } from './services/geolocation.service';
import { jwtDecode } from 'jwt-decode';
import { ApmService } from './services/apm.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  public appPages = [
    { title: 'Inbox', url: '/folder/Inbox', icon: 'mail' },
    { title: 'Outbox', url: '/folder/Outbox', icon: 'paper-plane' },
    { title: 'Favorites', url: '/folder/Favorites', icon: 'heart' },
    { title: 'Archived', url: '/folder/Archived', icon: 'archive' },
    { title: 'Trash', url: '/folder/Trash', icon: 'trash' },
    { title: 'Spam', url: '/folder/Spam', icon: 'warning' },
  ];
  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
  logout: any;
  offline: any;
  latitude: any;
  longitude: any;
  gpsTime: any;
  rootPage: any;
  onlineTimer: any;
  offlineTimer: any;
  onlineLoader = null;
  offlineLoader = null;
  isFirstOpen: boolean = true;
  onFirstOpen: boolean = false;
  ChangeDateDashboard: boolean = true;
  datebeforebg: any;
  public date: any = new Date();
  @ViewChildren(IonRouterOutlet) routerOutlet: QueryList<IonRouterOutlet>;

  constructor(private androidPermissions: AndroidPermissions, public statusBar: StatusBar, private platform: Platform,
    public global: GlobalPage, private router: Router, private geolocation: Geolocation,
    private storage1: Storage, public toastCtrl: ToastController, public userdetails: UserdetailPage,
    private device: Device, private network: Network, private location: Location, public loadingCtrl: LoadingController,
    private navCtrl: NavController, public menu: MenuController, public splashScreen: SplashScreen, private alertCtrl: AlertController, public geolocationService: GeolocationService,public firebaseX: FirebaseX,private apmService: ApmService) {
    this.storage1.create();
    this.getAndroidPermission();


      // Initialize Elastic APM tracking
      this.apmService.trackAppLifecycle('start', {
        platform: this.platform.platforms().join(','),
        deviceModel: this.device?.model || 'unknown',
        appVersion: '1.0.0'
      });


    this.platform.ready().then(async (readySource) => {
      this.global.uuid = this.device.uuid;
      // //alert( this.global.uuid);
      this.global.device_Platform = this.device.platform;
      this.global.model = this.device.model;
      this.global.device_Manufacture = this.device.manufacturer;
      this.global.device_Serial = (this.device.serial != null) ? this.device.serial : 'unknown';
      // let token;
      // if (this.platform.is('android')) {
      //   FCM.subscribeToTopic('Deals');
      //   // get FCM token
      //   await FCM.getToken().then(token => {
      //     this.global.token = token;
      //     this.userdetails.devicepushregistration();
      //   });
      //   //alert(this.global.token);
      // }
      if (this.platform.is('cordova')) {
         this.fcmtoken();
      }
     
      // Platform now ready, execute any required native code
      window.addEventListener('offline', async () => {
        this.apmService.trackConnectivityChange(true, 'network_reconnected');
        clearTimeout(this.onlineTimer);
        if (this.onlineLoader != null) {
          (await this.onlineLoader).dismiss();
        }
        this.global.isOffline = true;

        if (!this.global.offline && !this.global.isOfflineChangeByUser) {
          let toast = this.toastCtrl.create({
            message: 'Device will go Offline in 5 seconds',
            duration: 5000,
            position: 'bottom'
          });
          (await toast).present();
          this.offlineLoader = this.loadingCtrl.create({
            message: "Please wait...Moving to Offline mode"
          });
          (await this.offlineLoader).present();

          this.offlineTimer = setTimeout(async () => {
            (await this.offlineLoader).dismiss();

            this.global.refresh = false;
            (await this.toastCtrl.create({
              message: 'You are offline !',
              duration: 3000,
            })).present();
            this.global.offline = true;
            ////////////////--------To navigate back to dashboard if offline------/////////
            this.storage1.get("loginAuth").then((val) => {
              if (val) {
                this.router.navigate(['dashboard']);
              }
            });
          }, 5000);
        }
      });

      window.addEventListener('online', async () => {
        this.apmService.trackConnectivityChange(true, 'network_reconnected');
        this.storage1.set("online", "yes");
        this.global.isOffline = false;
        clearTimeout(this.offlineTimer);
        if (this.offlineLoader != null) {
          (await this.offlineLoader).dismiss();
        }
        this.onlineSwitch();

        // this.storage1.get("OfflineChangeTime").then((val)=>{
        //   if(val==null){
        //     this.storage1.set("OfflineChangeTime",new Date().getTime());
        //     this.onlineSwitch();
        //   }
        //   else{
        //     if((new Date().getTime()-val)>2000){
        //     this.storage1.set("OfflineChangeTime", new Date().getTime());
        //       this.onlineSwitch();
        //     }
        //   }
        // })

      });
      this.initializeApp();
      this.storage1.get("loginAuth").then((val) => {
        if (val) {
          this.global.apiKeyUrl = "https://maps.googleapis.com/maps/api/js?key=" + this.global.apiKey;
          $("<script>").attr({ src: this.global.apiKeyUrl }).appendTo("head");
        }
      })
    });

  this.statusBar.hide();
  this.statusBar.styleDefault();
  this.statusBar.overlaysWebView(false);

  }

  ngOnInit() {
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
   
  }

  async initializeApp() {
    this.platform.ready().then(async () => {
      console.log("ready")

       // Track app ready event
       this.apmService.trackEvent('AppReady', 'lifecycle', {
        platform: this.platform.platforms().join(','),
        timestamp: new Date().toISOString()
      });

      this.platform.resume.subscribe(() => {
        // Track app resume event
        this.apmService.trackAppLifecycle('resume', {
          timestamp: new Date().toISOString()
        });
        this.userdetails.deviceUpdateCheck();
        if (this.ChangeDateDashboard == true) {
       //   var d = this.date.getDate();

        //  var m = this.date.getMonth() + 1; //Jan is 0

         // var yyyy = this.date.getFullYear();
         var currentDate = new Date();
          var d = currentDate.getDate();
          var m = currentDate.getMonth() + 1; 
          var yyyy = currentDate.getFullYear();
          this.datebeforebg = this.global.getdate;
          this.global.getdate = m + '-' + d + '-' + yyyy;
          this.ChangeDateDashboard = true;
          this.storage1.get("loginAuth").then(async (val) => {
            console.log("val inside resume", val)
            if (val) {

              if (val.alternateDriverLogin == null) {
                console.log("current navigateurl", this.router.url)
                if (this.datebeforebg != this.global.getdate) {
                  console.log('route change');
                  this.global.Adddata(val);
                  console.log('val inside the after the change', val);
                  this.router.navigateByUrl('/altdashboard', { skipLocationChange: true }).then(() => {
                    this.router.navigate(['dashboard']);
                  });
                }
                else {
                  //stay on same route
                  console.log('same route stay');
                }
              }
            }
          });

        }
        this.ChangeDateDashboard = true;
      });
      this.statusBar.backgroundColorByHexString('#337395');
      setTimeout(() => {
        this.splashScreen.hide();
      }, 1000);
      this.statusBar.overlaysWebView(false);
      // if (this.platform.is("android")) {
      // this.geolocation.getCurrentPosition().then((resp) => {
      // }).catch((error) => {
      // });
      let disconnectSubscription = this.network.onDisconnect().subscribe(() => {
      });
      let connectSubscription = this.network.onConnect().subscribe(() => {
        // We just got a connection but we need to wait briefly
        // before we determine the connection type. Might need to wait.
        // prior to doing any api requests as well.
        // setTimeout(() => {
        //   if (this.network.type === 'wifi') {
        //   }
        // }, 3000);
      });
      // }

      this.storage1.get("loginAuth").then(async (val) => {
        if (val) {
          // const location = (await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION)).hasPermission
          // const location1 = (await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION)).hasPermission
          // if(location && location1){
          //   interval(30000).subscribe(() => {
          //     this.global.backgroundGPS();
          //   });
          //   this.global.AndroidPermission();
          //   this.global.locationenable();
          // }
          // else{
          //   setTimeout(() => {
          //     this.locationNotice();
          //   }, 3000);
          // }

          this.storage1.get("CurrentDate").then(async (val) => {
            if (!val) {
              this.storage1.set("CurrentDate", new Date().getDate())
            }
          })
          // this.userdetails.devicepushregistration();
          this.global.Adddata(val).then(() => {
            console.log(this.global.employee_ID,'257')
            if (this.platform.is('cordova')) {
              if(this.global.employee_ID != undefined) {
              this.geolocationService.backgroundgeolocationupdate();
              this.geolocationService.updateExtras();
            }
            } else {
             let pl= this.geolocationService.getLocation()
             console.log(pl, 'location-not-cordova');

            }
           
          });
          // Handle historical key name typo: some stored objects use 'tocken' instead of 'token'
          const rawJwt: any = (val as any).token || (val as any).tocken;
          let tokenData: any = null;
          try {
            if (rawJwt) {
              tokenData = jwtDecode(rawJwt);
              // Safely assign only if property exists
              if (tokenData && tokenData.family_name) {
                this.global.agencyId = tokenData.family_name;
              }
            } else {
              console.warn('[AppComponent] No JWT found on loginAuth object (expected token/tocken)');
            }
          } catch (e) {
            console.warn('[AppComponent] JWT decode failed', e);
          }
          // console.log('decoded', tokenData);
          if (this.global.token != '' && this.global.token != null && this.global.token != undefined) {
            this.userdetails.devicepushregistration();
          }
          if (val.alternateDriverLogin == null) {
            /**Setting the menu**/
            this.global.pages = [
              { title: 'Dashboard', component: "DashboardPage", icon: "home", link: ['/dashboard'] },
              { title: 'DriverManagement', component: "DriverManagementPage", icon: "list-outline", link: ['/driver-management'] },
              { title: 'Pending', component: "PendingTaskPage", icon: "car-outline", link: ['/pending'] },
              { title: 'Live', component: "LiveTaskPage", icon: "code-working", link: ['/live'] },
              { title: 'Completed', component: "CompletedTaskPage", icon: "checkmark-circle-outline", link: ['/completedtask'] },

            ];
            this.router.navigate(['dashboard'])
            // this.geolocationService.backgroundgeolocationupdate();
            // this.geolocationService.updateExtras();
          } else {
            this.global.pages = [
              { title: 'Dashboard', component: "DashboardPage", icon: "home", link: ['/dashboard'] },
              { title: 'DriverManagement', component: "DriverManagementPage", icon: "list-outline", link: ['/driver-management'] },
              { title: 'Pending', component: "PendingTaskPage", icon: "car-outline", link: ['/pending'] },
              { title: 'Live', component: "LiveTaskPage", icon: "code-working", link: ['/live'] },
              { title: 'Completed', component: "CompletedTaskPage", icon: "checkmark-circle-outline", link: ['/completedtask'] },
              { title: 'Assign Route', component: "AltLoginPage", icon: "person-add", link: ['/alt-login'] }
            ];
            this.storage1.get("RouteSelected").then(async (val) => {
              if (val) {
                this.storage1.get("CurrentDate").then(async (val) => {
                  if (val != new Date().getDate()) {
                    this.storage1.remove("routeStarted");
                    this.storage1.remove("RouteSelected");
                    this.storage1.remove("CurrentDate");
                    this.storage1.remove("loginAuth");
                    this.router.navigate(['alt-login']);
                    this.global.agencyId = this.global.globalheaderTimeZone = '';
                    this.global.authtoken = '';
                  }
                  else {
                    this.router.navigate(['dashboard'])
                  }
                })
              }
              else {
                this.router.navigate(['alt-login']);
              }
            })
          }
        }
        else {
          this.storage1.get("loginType").then((val) => {
            if (val) {
              this.global.pages = [
                { title: 'Dashboard', component: "DashboardPage", icon: "home", link: ['/dashboard'] },
                { title: 'DriverManagement', component: "DriverManagementPage", icon: "list-outline", link: ['/driver-management'] },
                { title: 'Pending', component: "PendingTaskPage", icon: "car-outline", link: ['/pending'] },
                { title: 'Live', component: "LiveTaskPage", icon: "code-working", link: ['/live'] },
                { title: 'Completed', component: "CompletedTaskPage", icon: "checkmark-circle-outline", link: ['/completedtask'] },
                { title: 'Assign Route', component: "AltLoginPage", icon: "person-add", link: ['/alt-login'] }
              ];
              this.global.agencyId = this.global.globalheaderTimeZone = '';
              this.global.authtoken = '';
              this.router.navigate(['alt-login'])
            }
            else {
              this.global.pages = [
                { title: 'Dashboard', component: "DashboardPage", icon: "home", link: ['/dashboard'] },
                { title: 'DriverManagement', component: "DriverManagementPage", icon: "list-outline", link: ['/driver-management'] },
                { title: 'Pending', component: "PendingTaskPage", icon: "car-outline", link: ['/pending'] },
                { title: 'Live', component: "LiveTaskPage", icon: "code-working", link: ['/live'] },
                { title: 'Completed', component: "CompletedTaskPage", icon: "checkmark-circle-outline", link: ['/completedtask'] },
              ];
              this.global.agencyId = this.global.globalheaderTimeZone = '';
              this.global.authtoken = '';
              this.router.navigate(['login']);
            }
          })
        }
      })
      this.backButtonEvent();
      this.onFirstOpen = true;
    });
  }

  //////-----Push Notification-----///////
  async fcmtoken() {
    try {
      if (this.platform.is('android')) {
        await this.firebaseX.subscribe('Deals').catch(() => undefined);
      }
      if (this.platform.is('ios')) {
        await this.firebaseX.grantPermission();
      }
      this.global.token = await this.firebaseX.getToken();
      console.log(this.global.token, 'token');
      this.firebaseX.onTokenRefresh().subscribe((token) => {
        this.global.token = token;
        console.log(token, 'token refreshed');
      });
      this.firebaseX.onMessageReceived().subscribe((data) => {
        console.log('Firebase message received:', data);
        this.storage1.get("loginAuth").then(async (val) => {
          this.storage1.remove("OfflineDate");
          if (val == null) {
            this.global.agencyId = this.global.globalheaderTimeZone = '';
            this.global.authtoken = '';
            this.router.navigate(['login']);
            return;
          }
          
          // Store global data once
          this.global.Adddata(val);
          
          if (!data.wasTapped) {
            // Foreground notification handling
            console.log('Foreground notification received');
            this.showToast(data);
            
            // Check if currently on dashboard - reload it
            if (this.router.url === '/dashboard') {
              console.log('Dashboard reload triggered by foreground notification');
              this.reloadDashboard();
              return; // Exit early to prevent other navigation
            }
            
            // Handle alternate driver login scenarios
            console.log(this.global.alternateDriverLogin, "this.global.alternateDriverLogin")
            if (this.global.alternateDriverLogin != null) {
              console.log('<-------------inside alternate driver login------------------->', val.alternateDriverLogin);
              
              if (this.router.url == '/routetrip') {
                console.log('<-------------router------------------->', this.router.url);
                this.reloadtheRoutetrip();
                return; // Exit early
              } else {
                console.log('Inside the app comp Else------->', val);
                console.log('this.router.url', this.router.url);

                this.router.navigateByUrl('/refreshdashboard', { skipLocationChange: true }).then(() => {
                  console.log('Inside alternate------->');
                  this.router.navigate(['dashboard']);
                });
                return; // Exit early
              }
            }
          } else {
            // Background notification tap handling
            console.log('Notification tapped from background');
            this.storage1.set("firebase", "gotnotification");
            this.router.navigate(['dashboard']);
            return; // Exit early
          }
          
          // Handle vehicle-specific notifications only if not handled above
          if (data.title) {
            if (data.title.includes("Vehicle")) {
              if (this.router.url == '/dashboard') {
                this.storage1.set("vehiclefcm", "gotnotification");
                this.reloadDashboard();
              } else if (this.router.url == '/driver-management') {
                this.storage1.set("vehiclefcm", "gotnotification");
                this.router.navigateByUrl('/altdashboard', { skipLocationChange: true }).then(() => {
                  this.router.navigate(['driver-management']);
                });
              }
            } else {
              // Non-vehicle notifications on dashboard
              if (this.router.url == '/dashboard') {
                this.storage1.set("firebase", "gotnotification");
                this.reloadDashboard();
              }
            }
          }
        });
      });
    } catch (error) {
      console.error('FirebaseX initialization failed', error);
    }
  }
  reloadtheRoutetrip() {
    let navigationExtras: NavigationExtras = {
      state: {
        route: this.global.selectMemberName,
        tblID: this.global.SelectTblid
      }
    };
    console.log('<-----------NavigationExtras--------------->', navigationExtras);
    this.router.navigateByUrl('/altdashboard', { skipLocationChange: true }).then(() => {
      this.router.navigate(['routetrip'], navigationExtras);
    });
  }
  showToast(data) {
    if(data.title != undefined && data.body != undefined){
    const title = data.title || data.notification?.title || data.aps?.alert?.title;
    const body = data.body || data.notification?.body || data.aps?.alert?.body;
    if (this.platform.is('android')) {
      this.toastCtrl.create({
        message: `${title} : \n${body}`,
        position: 'bottom',
        buttons: [{ side: 'end', text: 'x', role: 'cancel' }],
      }).then((toastRes) => toastRes.present());
    }
    if (this.platform.is('ios')) {
      this.toastCtrl.create({
        message: `${title} : \n${body}`,
        position: 'bottom',
        duration: 10000,
        cssClass: "classToast",
        buttons: [{ side: 'end', text: 'x', role: 'cancel' }],
      }).then((toastRes) => toastRes.present());
    }
  }
}

  async onlineSwitch() {
    if (this.global.offline && !this.global.isOfflineChangeByUser) {
      if (this.onFirstOpen) {
        let toast = this.toastCtrl.create({
          message: 'Device will go Online in 5 seconds',
          duration: 5000,
          position: 'bottom'
        });
        (await toast).present();
        this.onlineLoader = this.loadingCtrl.create({
          message: "Please wait...Moving to Online"
        });
        (await this.onlineLoader).present();
        this.onlineTimer = setTimeout(async () => {
          (await this.onlineLoader).dismiss();

          this.global.refresh = true;
          (await this.toastCtrl.create({
            message: 'You are online now !',
            duration: 3000,
          })).present();
          this.storage1.set("online", "yes");
          this.global.offline = false;
          this.isFirstOpen = false;
          // this.menu.enable(true, 'custom');
          ////////////////------TO SEND OFFLINE DATA----------------//////////
          // this.selectsqlroute();
          ////////////////--------To navigate back to dashboard if offline------/////////
          this.storage1.get("loginAuth").then((val) => {
            if (val) {
              this.router.navigate(['dashboard']);
            }
          });
        }, 5000);
      }
    }
  }

  lastTimeBackPress = 0;
  timePeriodToExit = 2000;
  backButtonEvent() {
    document.addEventListener("backbutton", async () => {
      try {
        const element = await this.toastCtrl.getTop();
        if (element) {
          element.dismiss();
          return;
        }
      } catch (error) {
        console.log(error);
      }
      this.routerOutlet.forEach(async (outlet: IonRouterOutlet) => {
        if (this.router.url == '/dashboard') {     //// App Release

          // if (view.component.name == "DashboardPage") {                 //// App Testing

          if ((new Date().getTime() - this.lastTimeBackPress) < this.timePeriodToExit) {   ////---To check time delay--////
            navigator['app'].exitApp(); //Exit from app
          } else {
            let toast = this.toastCtrl.create({
              message: 'Press back again to exit App?',
              duration: 2000,
              position: 'bottom'
            });
            (await toast).present();
            this.lastTimeBackPress = new Date().getTime();
          }
        }
        else if (this.router.url == '/login') {     //// App Release

          // if (view.component.name == "LoginPage") {                 //// App Testing

          if ((new Date().getTime() - this.lastTimeBackPress) < this.timePeriodToExit) {   ////---To check time delay--////
            navigator['app'].exitApp(); //Exit from app
          } else {
            let toast = this.toastCtrl.create({
              message: 'Press back again to exit App?',
              duration: 2000,
              position: 'bottom'
            });
            (await toast).present();
            this.lastTimeBackPress = new Date().getTime();
          }
        }
        else if (this.router.url == '/alt-login') {     //// App Release

          // if (view.component.name == "AltLoginPage") {                 //// App Testing

          if ((new Date().getTime() - this.lastTimeBackPress) < this.timePeriodToExit) {   ////---To check time delay--////
            navigator['app'].exitApp(); //Exit from app
          } else {
            let toast = this.toastCtrl.create({
              message: 'Press back again to exit App?',
              duration: 2000,
              position: 'bottom'
            });
            (await toast).present();
            this.lastTimeBackPress = new Date().getTime();
          }
        }
        // else if (outlet.canGoBack()) {
        //   console.log('backkk')
        //   outlet.pop();
        // }
        else {
          this.router.navigate(['dashboard']);
        }
      });
    });
  }

  // async locationNotice(){
  //   const toast = this.alertCtrl.create({
  //     message: 'This app collects the Location data to enable tracking your Trips to work and calculate distance travelled even when the app is closed or not in use',
  //     header: 'Background Location',
  //     backdropDismiss:false,
  //     buttons: [
  //       {
  //         text: 'Deny',
  //         handler: async () => {
  //             navigator['app'].exitApp();
  //         },
  //       },
  //       {
  //         text: "Accept",
  //         handler: async () => {
  //           this.global.backgroundGPS();
  //           interval(30000).subscribe(() => {
  //             this.global.backgroundGPS();
  //           });
  //           this.global.AndroidPermission();
  //           this.global.locationenable();
  //           (await toast).dismiss();
  //         },
  //       }
  //     ],
  //   })
  //   await (await toast).present()
  // }
  async getAndroidPermission() {
    const ready = !!await this.platform.ready();
    if (ready) {

      const Finelocation = (await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION)).hasPermission
      const AccessCoarseLocation = (await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION)).hasPermission
      if (Finelocation && AccessCoarseLocation) {
        if(this.global.employee_ID != undefined) {
          this.geolocationService.backgroundgeolocationupdate();
          this.geolocationService.updateExtras();
        }
      }
      else {
        const alert = this.alertCtrl.create({
          header: 'Background Location!',
          message: 'This app collect your location data to capture your live location while providing services to your clients!',
          buttons: [
            {
              text: 'Deny',
              handler: async () => {
                navigator['app'].exitApp();
              },
            },
            {
              text: "Accept",
              handler: async () => {
                this.global.AndroidPermission();
                this.global.requestPushPermission();
                if(this.global.employee_ID != undefined) {
                  this.geolocationService.backgroundgeolocationupdate();
                  this.geolocationService.updateExtras();
                }
                //this.requestGPSPermission()
              },
            }
          ],
          backdropDismiss: false,
        });
        await (await alert).present();
      }
    }
  }

  private reloadDashboard() {
    console.log('reloadDashboard called - Current URL:', this.router.url);
    
    // Safety check to prevent infinite loops
    if (this.router.url !== '/dashboard') {
      console.log('Not on dashboard, skipping reload');
      return;
    }
    
    // Set notification flag
    this.storage1.set("firebase", "gotnotification");
    
    console.log('Navigating away from dashboard to trigger reload...');
    this.router.navigateByUrl('/altdashboard', { skipLocationChange: true }).then(() => {
      console.log('Now navigating back to dashboard...');
      this.router.navigate(['/dashboard']).then(() => {
        console.log('Dashboard reload completed successfully');
      }).catch((error) => {
        console.error('Error navigating back to dashboard:', error);
      });
    }).catch((error) => {
      console.error('Error navigating to altdashboard:', error);
    });
  }

}

